import { render, staticRenderFns } from "./Soundtrack.vue?vue&type=template&id=1987b5d0&scoped=true&lang=pug"
import script from "./Soundtrack.vue?vue&type=script&lang=js"
export * from "./Soundtrack.vue?vue&type=script&lang=js"
import style0 from "./Soundtrack.vue?vue&type=style&index=0&id=1987b5d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987b5d0",
  null
  
)

export default component.exports